/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { ListItem, ListItemText, Collapse } from '@material-ui/core'
import { ExpandLess, ExpandMore } from '@material-ui/icons'

const styles = theme => ({

})

class ScreenItem extends Component {
    state = {  }

    componentDidMount () {
        console.log("Screen :: Config Route : ", this.props.config.route)
        console.log("Screen :: Current Route : ", this.props.cur_route)
    }

    renderScreen = () => {
        if (this.props.config.show_in_sidebar === undefined) {
            return (
                <Fragment>
                    <ListItem
                        id = {this.props.id}
                        style = {{paddingLeft : (this.props.level * 20) + "px"}}
                        key = {this.props.config.route}
                        button
                        selected = {this.props.cur_route === this.props.config.route}
                        onClick = {() => this.props.goToPage(this.props.config.route)}
                    >
                    <ListItemText
                        primary={this.props.config.name}
                        primaryTypographyProps={{ variant:  "body2"}}
                    />
                    </ListItem>
                </Fragment>
            )
        }

        if (this.props.config.show_in_sidebar === true) {
            return (
                <Fragment>
                    <ListItem
                        id = {this.props.id}
                        style = {{paddingLeft : (this.props.level * 20) + "px"}}
                        key = {this.props.config.route}
                        button
                        selected = {this.props.cur_route === this.props.config.route}
                        onClick = {() => this.props.goToPage(this.props.config.route)}
                    >
                        <ListItemText
                            primary={this.props.config.name}
                            primaryTypographyProps={{ variant:  "body2"}}
                        />
                    </ListItem>
                </Fragment>
            )
        } else {
            return null
        }
    }
    render() { 
        return this.renderScreen()
    }
}
 
export default withStyles(styles)(ScreenItem);